import {createSelector} from '@reduxjs/toolkit';
import {RootState} from 'redux/rootReducer';

export const userStoryStatus = createSelector(
  [(state: RootState) => state.userStory.isLoading],
  isLoading => isLoading,
);
export const userStoryFailure = createSelector(
  [(state: RootState) => state.userStory.errorUserStoryState],
  errorUserStoryState => errorUserStoryState,
);
export const userStorySuccess = createSelector(
  [(state: RootState) => state.userStory.successUserStoryState],
  successUserStoryState => successUserStoryState,
);
export const backlogList = createSelector(
  [(state: RootState) => state.userStory.backlogsList],
  backlogs => backlogs,
);
export const backlogTotalPages = createSelector(
  [(state: RootState) => state.userStory.totalBacklogPages],
  totalBacklogPages => totalBacklogPages,
);

export const selectUserStoryID = createSelector(
  [(state: RootState) => state.userStory.selectedStoryData.id],
  id => id,
);

export const selectUserStoryData = createSelector(
  [(state: RootState) => state.userStory.selectedStoryData.data],
  data => data,
);
